//
// TextAttributes.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AttributesModel";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "@sas-dvr/ltjs-commons/styles/FontWeight";
import "@sas-dvr/ltjs-commons/styles/FontStyle";
import "@sas-dvr/ltjs-commons/models/attributes/TextAttributesInterface";

var TextAttributes = createModule("gtl::TextAttributes", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::AttributesModel"], EventDispatcher, [
    ,
    {
        altTextColor: 10,
        fontFamily: 7,
        transparency: 5,
        fontSize: 1,
        fontStyle: 4,
        textColor: 10,
        fontWeight: 4,
    },
    ,
    ,
    {
        copyFromBundle: [0,1],
        asTextAttributesInterface: [1],
        setStyle: [0,1],
        setStyleElement: [0,4],
        setStyleElementChain: [0,[4]],
        copyFrom: [0,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default TextAttributes;
